export default __webpack_public_path__ + "static/media/suitemaster_3.f65ac175.jpg";